import React from "react";
import { NavLink } from "react-router-dom";

export const NavBarBrand = () => {
  return (
    <div className="nav-bar__brand">
      <NavLink to="/">
        <img
          className="nav-bar__logo"
          src="https://dopl-public-files.s3.us-west-2.amazonaws.com/dopl-logo-compliant.png"
          alt="Auth0 shield logo"
          height="36"
        />
      </NavLink>
    </div>
  );
};
